import { useEffect } from 'react';
import {
  useFeatureToggle,
  TOGGLE_NAMES,
} from 'platform/utilities/feature-toggles';
import { setConditionsTransformConfig } from '../utils';

/**
 * Custom hook for migrating users to the multi-step conditions workflow ("v2 flow")
 * The v2 flow is fully enabled for new Form526 applications as of May 2026.
 * This hook is used to transform IPFs that are still on the v1 flow.
 *
 * @param {object} options
 * @param {boolean} options.togglesLoading - True while feature toggles are still resolving.
 * @param {Function} options.setFormData   - Redux dispatch wrapper.
 */
const useConditionsTransformConfig = ({ togglesLoading, setFormData }) => {
  const { useToggleValue } = useFeatureToggle();

  const transformEnabled = useToggleValue(
    TOGGLE_NAMES.disabilityCompNewConditionsWorkflowTransformIpfs,
  );
  const rollbackEnabled = useToggleValue(
    TOGGLE_NAMES.disabilityCompNewConditionsWorkflowRollbackIpfs,
  );

  if (!togglesLoading) {
    setConditionsTransformConfig({
      transformEnabled,
      rollbackEnabled,
      setFormData,
    });
  }

  useEffect(() => {
    return () => {
      setConditionsTransformConfig(undefined);
    };
  }, []);
};

export default useConditionsTransformConfig;
